import styles from 'css/components/blue-button.module.css'
import arrowCurvedIcon from 'img/arrow-curved.svg'
import caretRightIcon from 'img/caret-right.svg'
import commentIcon from 'img/dashicons-admin-comments.svg'
import downloadWhiteIcon from 'img/dashicons-download-white.svg'
import reverseMarkIcon from 'img/reverse-mark.svg'
import updateIcon from 'img/plus.svg'
import refreshWhiteIcon from 'img/refresh-white.svg'
import React from 'react'

interface BlueButtonProps {
    disabled?: boolean;
    visible?: boolean;
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;    
    label?: React.ReactNode;
    icon?: React.ReactNode;
    iconPosition?: 'left' | 'right';
    type?: 'button' | 'submit' | 'reset';
}

export const BlueButton: React.FC<BlueButtonProps> = ({
    disabled = false,
    visible = true,
    onClick,
    label,
    icon,
    iconPosition = 'left',
    type = 'button'
}) => {
    return (
        <button
            type={type}
            className={`${styles.blueButton}`}
            onClick={onClick}
            disabled={disabled}
            style={{ visibility: visible ? 'visible' : 'hidden' }}
        >
            {icon && iconPosition === 'left' && <span className={styles.blueButton__icon}>{icon}</span>}
            {label && label}
            {icon && iconPosition === 'right' && <span className={styles.blueButton__icon}>{icon}</span>}
        </button>
    )
}

export const DoneButton = ({disabled, onClick, type}: {disabled?: boolean, onClick?: () => void, type?: 'button' | 'submit' | 'reset'}) => {
    return (
        <BlueButton label="Done" onClick={onClick || (() => {})} disabled={disabled} type={type} />
    )
}

export const LessonButton = ({onClick}: {onClick: () => void}) => {
    return (
        <BlueButton label="Lessons" onClick={onClick} icon={<img src={arrowCurvedIcon} />} />
    )
}

export const ClassButton = ({onClick}: {onClick: () => void}) => {
    return (
        <BlueButton label="Class" onClick={onClick} />
    )
}

export const DownloadClassButton = ({onClick,}: {onClick: () => void}) => {
    return (
        <BlueButton label="Download Class" onClick={onClick} icon={<img src={downloadWhiteIcon} />} />
    )
}

export const DownloadButton = ({onClick}: {onClick: () => void}) => {
    return (
        <BlueButton label="Download" onClick={onClick} icon={<img src={downloadWhiteIcon} />} />
    )
}

export const ReverseMarkButton = ({onClick, visible}: {onClick: () => void, visible?: boolean}) => {
    return (
        <div className={styles.reverseMarkButton}>
            <BlueButton 
                label={
                    <span>
                        REVERSE<br />
                        MARK
                    </span>
                }
                onClick={onClick} 
                visible={visible} 
                icon={<img src={reverseMarkIcon} />}
            />
        </div>
    )
}

export const CommentButton = ({onClick, visible}: {onClick: () => void, visible?: boolean}) => {
    return (
        <BlueButton onClick={onClick} icon={<img src={commentIcon} />} visible={visible} />
    )
}

export const PreviousQuestionButton = ({onClick, visible}: {onClick: () => void, visible?: boolean}) => {
    return (
        <BlueButton label="Previous Question" onClick={onClick} iconPosition="left" visible={visible} />
    )
}

export const NextQuestionButton = ({onClick, visible}: {onClick: () => void, visible?: boolean}) => {
    return (
        <BlueButton label="Next Question" onClick={onClick} icon={<img src={caretRightIcon} />} iconPosition="right" visible={visible} />
    )
}

export const UpdateClassButton = ({onClick}: {onClick: () => void}) => {
    return (
        <BlueButton label="Update Class" onClick={onClick} icon={<img src={updateIcon} />} />
    )
}

export const GetNewQuestionButton = ({onClick}: {onClick: () => void}) => {
    return (
        <BlueButton label="Get New Question" onClick={onClick} icon={<img src={refreshWhiteIcon} />} />
    )
}

export const NextSlideButton = ({onClick}: {onClick: () => void}) => {
    return (
        <BlueButton label="Next Slide" onClick={onClick} iconPosition="right" />
    )
}

export const PreviousSlideButton = ({onClick}: {onClick: () => void}) => {
    return (
        <BlueButton label="Previous Slide" onClick={onClick} iconPosition="left" />
    )
}

export const RegenerateQuestionsButton = ({onClick, disabled}: {onClick: () => void, disabled?: boolean}) => {
    return (
        <BlueButton label="Regenerate Questions" onClick={onClick} disabled={disabled} icon={<img src={refreshWhiteIcon} />} />
    )
}

export const CopyLessonButton = ({onClick, disabled}: {onClick: () => void, disabled?: boolean}) => {
    return (
        <BlueButton label="Copy Lesson" onClick={onClick} disabled={disabled} />
    )
}